// extracted by mini-css-extract-plugin
module.exports = {"Package":"_1Bdz-fUyG8l6_Bg4TOip3X"};